export default {


  data() {
    return {
      searchQuery: null,
      filterTags: []
    }
  },

  computed: {
    filteredRecords() {
      if (!this.searchQuery) {
        return this.records
      }
      let normalizedSearch = this.searchQuery.toLowerCase()
      return this.records.filter((workflow)=>{
        return workflow.searchContent.indexOf(normalizedSearch) >= 0
      })
    }
  }

}